const LABELS = {
  bot_affiliate_profit: "Bot Affiliate Profit",
  trading_affiliate_profit: "Trading Affiliate Profit",
  bot_license_fee: "Bot License Fee",
  affiliate_commission: "Affiliate Commission",
  leadership_reward: "Leadership Reward",
  performance_award: "Performance Award",
  working: "Working",
  non_working: "Non-Working",
  nonworking: "Non-Working",
};

export const formatIncomeSourceKey = (raw) => {
  const key = String(raw || "").trim().toLowerCase();
  if (LABELS[key]) return LABELS[key];
  return String(raw || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
